import actions from './actions';

const {
  LIST_SUCURSAL,
  LIST_SUCURSAL_SELECTBOX,
  CREATE_SUCURSAL,
  READ_SUCURSAL,
  UPDATE_SUCURSAL,  
  LIST_SUCURSAL_UNIDADES_MEDICAS,
  CLEAR_SUCURSAL_UNIDADES_MEDICAS,
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},
  dataUnidadesMedicas: [],  
};


const sucursalCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_SUCURSAL:
      return {
        ...state,
        data: data
      }
    case LIST_SUCURSAL_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_SUCURSAL:
      return {
        ...state,
        record: data
      }
    case READ_SUCURSAL:
      return {
        ...state,
        record: data
      }
    case UPDATE_SUCURSAL:
      return {
        ...state,
        record: data
      }
    case LIST_SUCURSAL_UNIDADES_MEDICAS:
      return {
        ...state,
        dataUnidadesMedicas: data
      }
    case CLEAR_SUCURSAL_UNIDADES_MEDICAS:
      return {
        ...state,
        dataUnidadesMedicas: []
      }

    default:
      return state;
  }
};


export default sucursalCrudReducer;
